export interface Video {
  id: string;
  title: string;
  description: string;
  thumbnail: string;
  category: string;
  categorySlug: string;
  duration: string;
  views: number;
  rating: number;
  publishDate: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  videoUrl?: string;
  director?: string;
  cast?: string[];
}

export const categories = [
  { name: '电影', slug: 'movie', icon: 'ri-movie-2-line', count: 1280 },
  { name: '电视剧', slug: 'tv-series', icon: 'ri-tv-2-line', count: 960 },
  { name: '综艺', slug: 'variety', icon: 'ri-emotion-laugh-line', count: 756 },
  { name: '动漫', slug: 'anime', icon: 'ri-ghost-smile-line', count: 520 },
  { name: '纪录片', slug: 'documentary', icon: 'ri-global-line', count: 340 },
  { name: '短视频', slug: 'short-video', icon: 'ri-smartphone-line', count: 2100 },
  { name: '音乐', slug: 'music', icon: 'ri-music-2-line', count: 890 },
  { name: '游戏', slug: 'gaming', icon: 'ri-gamepad-line', count: 670 },
];

export const videos: Video[] = [
  {
    id: 'v001',
    title: '星际穿越：跨越时空的父女情深',
    description: '在不久的未来，地球面临着严重的环境危机。前NASA宇航员库珀被选中参加一项穿越虫洞的星际任务，寻找适合人类居住的新家园。在与女儿墨菲的告别中，一段跨越时空的亲情故事就此展开。本片由克里斯托弗·诺兰执导，融合了硬核科幻与深沉情感，带来震撼的视听体验与心灵触动。',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cinematic%20space%20scene%20with%20a%20massive%20black%20hole%20and%20starship%2C%20warm%20golden%20light%20contrasting%20deep%20space%2C%20epic%20movie%20poster%20style%2C%20dramatic%20composition%20with%20silhouetted%20astronaut%2C%20high%20contrast%2C%20emotional%20and%20grand%20scale%2C%20clean%20minimalist%20background%20with%20cinematic%20lighting&width=640&height=360&seq=video-thumb-001&orientation=landscape',
    category: '电影',
    categorySlug: 'movie',
    duration: '02:49:12',
    views: 1285000,
    rating: 9.3,
    publishDate: '2026-07-28',
    tags: ['科幻', '冒险', '剧情', '诺兰'],
    isHot: true,
    isNew: false,
    director: '克里斯托弗·诺兰',
    cast: ['马修·麦康纳', '安妮·海瑟薇', '杰西卡·查斯坦'],
  },
  {
    id: 'v002',
    title: '蓝色星球3：深海之谜',
    description: '《蓝色星球》系列第三部重磅回归！这一次，我们深入从未被探索过的深海领域，揭开地球上最神秘生态系统的面纱。从发光的水母群到巨型深海章鱼，每一帧画面都是对自然奇迹的致敬。4K超高清拍摄技术，带您领略海洋深处的极致之美。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20underwater%20scene%20with%20glowing%20jellyfish%20and%20marine%20life%2C%20deep%20blue%20ambient%20light%2C%20documentary%20cinematography%20style%2C%20mysterious%20and%20beautiful%20underwater%20world%2C%20clean%20simple%20background%2C%20high%20detail%20natural%20photography&width=640&height=360&seq=video-thumb-002&orientation=landscape',
    category: '纪录片',
    categorySlug: 'documentary',
    duration: '00:58:30',
    views: 896000,
    rating: 9.6,
    publishDate: '2026-08-01',
    tags: ['纪录片', '海洋', '自然', '4K'],
    isHot: true,
    isNew: true,
    director: '詹姆斯·霍尼伯内',
    cast: ['大卫·爱登堡'],
  },
  {
    id: 'v003',
    title: '欢乐喜剧人：爆笑合集2026',
    description: '最新一季欢乐喜剧人强势回归！沈腾、贾玲、岳云鹏等喜剧大咖齐聚一堂，带来前所未有的爆笑盛宴。本期特别企划「穿越古代」主题，看喜剧人们如何用现代幽默碰撞古代场景，笑料百出，全程高能。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20comedians%20performing%2C%20bright%20warm%20stage%20lighting%2C%20laughing%20audience%20silhouettes%2C%20entertainment%20show%20atmosphere%2C%20clean%20studio%20background%2C%20vibrant%20and%20energetic%20composition&width=640&height=360&seq=video-thumb-003&orientation=landscape',
    category: '综艺',
    categorySlug: 'variety',
    duration: '01:32:15',
    views: 2150000,
    rating: 9.1,
    publishDate: '2026-07-30',
    tags: ['综艺', '喜剧', '搞笑', '明星'],
    isHot: true,
    isNew: true,
    cast: ['沈腾', '贾玲', '岳云鹏'],
  },
  {
    id: 'v004',
    title: '鬼灭之刃：无限城篇',
    description: '炭治郎一行人终于抵达无限城，与鬼舞辻无惨的最终决战即将展开。剧场版级别的作画质量，震撼的打斗场面，催人泪下的角色故事。本季为鬼灭之刃系列最高潮篇章，不容错过！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20style%20demon%20slayer%20warrior%20with%20sword%20in%20dark%20castle%2C%20dramatic%20red%20and%20black%20color%20scheme%2C%20dynamic%20action%20pose%2C%20Japanese%20anime%20art%20style%2C%20clean%20background%20with%20fire%20effects%2C%20epic%20cinematic%20lighting&width=640&height=360&seq=video-thumb-004&orientation=landscape',
    category: '动漫',
    categorySlug: 'anime',
    duration: '00:24:00',
    views: 3560000,
    rating: 9.5,
    publishDate: '2026-08-02',
    tags: ['动漫', '热血', '战斗', '日漫'],
    isHot: true,
    isNew: true,
    cast: ['花江夏树', '鬼头明里', '下野纮'],
  },
  {
    id: 'v005',
    title: '长安十二时辰：盛世危机',
    description: '唐天宝三年，上元节前夕，长安城陷入了一场精心策划的阴谋之中。死囚张小敬临危受命，与靖安司李必携手，在十二个时辰内找出幕后真凶，拯救长安城于危难之间。精致的服化道还原大唐盛世，悬疑剧情环环相扣。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20cityscape%20with%20lanterns%20and%20traditional%20architecture%2C%20warm%20golden%20evening%20light%2C%20period%20drama%20cinematography%2C%20mysterious%20atmosphere%2C%20clean%20composition%20with%20silhouettes%20in%20traditional%20costumes%2C%20cinematic%20lighting&width=640&height=360&seq=video-thumb-005&orientation=landscape',
    category: '电视剧',
    categorySlug: 'tv-series',
    duration: '00:45:00',
    views: 1890000,
    rating: 9.2,
    publishDate: '2026-07-25',
    tags: ['古装', '悬疑', '历史', '国产剧'],
    isHot: true,
    isNew: false,
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围'],
  },
  {
    id: 'v006',
    title: '街头美食之旅：成都篇',
    description: '跟着美食博主走进成都的大街小巷，探寻最地道的川味美食。从清晨的担担面到深夜的串串香，从百年老店到苍蝇馆子，每一口都是舌尖上的惊喜。本期特别推荐：隐藏在小巷深处的绝密配方火锅。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20street%20food%20scene%20in%20Chengdu%20with%20colorful%20spicy%20dishes%2C%20steaming%20hotpot%20and%20noodles%2C%20warm%20ambient%20light%2C%20food%20documentary%20style%2C%20vibrant%20red%20and%20warm%20tones%2C%20clean%20simple%20background%2C%20appetizing%20composition&width=640&height=360&seq=video-thumb-006&orientation=landscape',
    category: '短视频',
    categorySlug: 'short-video',
    duration: '00:12:45',
    views: 780000,
    rating: 9.0,
    publishDate: '2026-08-03',
    tags: ['美食', '旅行', '成都', '探店'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'v007',
    title: '周杰伦2026世界巡回演唱会：台北站',
    description: '华语乐坛天王周杰伦2026世界巡回演唱会台北站完整版！经典曲目《晴天》《七里香》《夜曲》等悉数登场，更有神秘嘉宾惊喜现身。顶级舞美灯光，沉浸式音乐体验，带你重温青春记忆。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20dramatic%20lighting%20and%20laser%20effects%2C%20massive%20crowd%20silhouettes%2C%20music%20concert%20atmosphere%2C%20warm%20golden%20and%20purple%20stage%20lights%2C%20clean%20dark%20background%2C%20energetic%20live%20performance%20photography&width=640&height=360&seq=video-thumb-007&orientation=landscape',
    category: '音乐',
    categorySlug: 'music',
    duration: '02:18:30',
    views: 4560000,
    rating: 9.8,
    publishDate: '2026-07-20',
    tags: ['音乐', '演唱会', '周杰伦', '华语'],
    isHot: true,
    isNew: false,
    cast: ['周杰伦'],
  },
  {
    id: 'v008',
    title: '黑神话：悟空 - 全剧情攻略',
    description: '国产3A大作《黑神话：悟空》全剧情通关攻略！从花果山到大雷音寺，详细解析每个Boss的招式与打法，隐藏关卡全收集路线。天命人的西游之路，每一帧都是壁纸级别的视觉盛宴。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20monkey%20king%20warrior%20in%20dark%20forest%2C%20game%20cinematic%20style%2C%20dramatic%20lighting%20with%20golden%20accents%2C%20fantasy%20atmosphere%2C%20epic%20composition%2C%20clean%20dark%20background%20with%20particle%20effects&width=640&height=360&seq=video-thumb-008&orientation=landscape',
    category: '游戏',
    categorySlug: 'gaming',
    duration: '03:25:00',
    views: 1670000,
    rating: 9.4,
    publishDate: '2026-07-15',
    tags: ['游戏', '攻略', '黑神话', '国产3A'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'v009',
    title: '流浪地球3：新家园',
    description: '地球在宇宙中漂流了数十年后，终于抵达了新的星系。然而，新家园并非想象中的乐土，未知的威胁悄然降临。刘培强牺牲后的世界，新一代领航员将如何面对前所未有的挑战？中国科幻电影的里程碑之作再次突破想象边界。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20city%20on%20a%20distant%20planet%20with%20massive%20engines%2C%20warm%20orange%20and%20blue%20contrasting%20light%2C%20epic%20cinematic%20scale%2C%20clean%20minimalist%20background%2C%20dramatic%20composition%2C%20Chinese%20sci-fi%20movie%20poster%20style&width=640&height=360&seq=video-thumb-009&orientation=landscape',
    category: '电影',
    categorySlug: 'movie',
    duration: '02:32:18',
    views: 3200000,
    rating: 9.0,
    publishDate: '2026-08-04',
    tags: ['科幻', '国产', '大片', '刘慈欣'],
    isHot: true,
    isNew: true,
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健'],
  },
  {
    id: 'v010',
    title: '甄嬛传：经典重温',
    description: '经典宫斗剧《甄嬛传》高清修复版全集上线！从少女入宫到太后之路，甄嬛在深宫中的每一步都惊心动魄。孙俪教科书级别的演技，精良的制作水准，即使多年后再看依然让人欲罢不能。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20palace%20drama%20scene%20with%20elegant%20woman%20in%20traditional%20qing%20dynasty%20costume%2C%20warm%20candlelight%20and%20red%20lanterns%2C%20historical%20drama%20cinematography%2C%20clean%20ornate%20background%2C%20soft%20romantic%20lighting%2C%20classical%20Chinese%20aesthetic&width=640&height=360&seq=video-thumb-010&orientation=landscape',
    category: '电视剧',
    categorySlug: 'tv-series',
    duration: '00:45:00',
    views: 980000,
    rating: 9.7,
    publishDate: '2026-06-10',
    tags: ['古装', '宫斗', '经典', '国产剧'],
    isHot: false,
    isNew: false,
    director: '郑晓龙',
    cast: ['孙俪', '陈建斌', '蔡少芬'],
  },
  {
    id: 'v011',
    title: '极速挑战：F1摩纳哥大奖赛精华',
    description: '2026赛季F1摩纳哥大奖赛精彩集锦！蒙特卡洛赛道上的速度与激情，弯道超车的精彩瞬间，车队策略的斗智斗勇。汉密尔顿与维斯塔潘的巅峰对决，让这场街道赛成为本赛季最令人难忘的一站。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Formula%201%20race%20car%20on%20Monaco%20street%20circuit%2C%20dynamic%20motion%20blur%2C%20warm%20Mediterranean%20sunlight%2C%20sports%20broadcast%20style%2C%20clean%20track%20background%2C%20high%20speed%20action%20photography%2C%20vibrant%20racing%20colors&width=640&height=360&seq=video-thumb-011&orientation=landscape',
    category: '短视频',
    categorySlug: 'short-video',
    duration: '00:08:30',
    views: 450000,
    rating: 8.9,
    publishDate: '2026-07-29',
    tags: ['体育', 'F1', '赛车', '集锦'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'v012',
    title: '一人之下：罗天大醮篇',
    description: '张楚岚参加异人界的罗天大醮，各路异人齐聚龙虎山。精彩的异能对决，幽默搞笑的日常，以及深藏不露的江湖阴谋。国漫之光《一人之下》最经典的篇章，打斗场面燃到炸裂！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20style%20martial%20arts%20fighter%20on%20mountain%20temple%2C%20dynamic%20action%20with%20energy%20effects%2C%20warm%20sunset%20lighting%2C%20donghua%20art%20style%2C%20clean%20background%20with%20clouds%2C%20epic%20cinematic%20composition&width=640&height=360&seq=video-thumb-012&orientation=landscape',
    category: '动漫',
    categorySlug: 'anime',
    duration: '00:22:00',
    views: 1230000,
    rating: 9.3,
    publishDate: '2026-07-18',
    tags: ['动漫', '国漫', '热血', '异能'],
    isHot: false,
    isNew: false,
  },
];

export const trendingVideos = videos.filter(v => v.isHot);
export const latestVideos = videos.filter(v => v.isNew);

export const aboutStats = {
  totalVideos: 12580,
  dailyActiveUsers: 3500000,
  totalPlayCount: 890000000,
  yearsRunning: 8,
};

export const testimonials = [
  {
    name: '张先生',
    role: '资深影迷',
    content: '91视频网站的画质真的太棒了！4K高清播放流畅不卡顿，片源更新也很快，现在每天都要上来看看有什么新内容。',
    rating: 5,
  },
  {
    name: '李女士',
    role: '家庭用户',
    content: '全家人都在用91视频网站，综艺节目更新及时，动漫资源也很丰富。最重要的是免费，真的非常良心！',
    rating: 5,
  },
  {
    name: '王同学',
    role: '大学生',
    content: '作为一个纪录片爱好者，91视频网站的纪录片专区让我惊喜。BBC、国家地理的资源都有，学习娱乐两不误。',
    rating: 5,
  },
  {
    name: '赵女士',
    role: '上班族',
    content: '下班后最好的放松方式就是打开91视频网站刷短视频，内容有趣又不会太长，轻松解压，推荐给所有上班族。',
    rating: 4,
  },
];

export const faqData = [
  {
    question: '91视频网站是否需要注册才能观看？',
    answer: '不需要！91视频网站的所有视频内容均可免费在线观看，无需注册或登录。我们致力于为用户提供最便捷的观看体验。',
  },
  {
    question: '视频播放支持哪些清晰度？',
    answer: '我们支持从360P到4K超高清的多种清晰度选择，系统会根据您的网络状况自动推荐最合适的清晰度，您也可以手动切换。',
  },
  {
    question: '91视频网站的内容多久更新一次？',
    answer: '我们的内容团队每天24小时不间断更新，热门影视在院线下映后最快30天内上线，综艺节目同步更新，确保您能第一时间看到最新内容。',
  },
  {
    question: '可以在手机上观看91视频网站吗？',
    answer: '当然可以！91视频网站完美适配手机、平板、电脑等各类设备，无论您在哪里，都能享受流畅的观看体验。',
  },
  {
    question: '视频出现卡顿怎么办？',
    answer: '建议检查网络连接，或尝试降低清晰度。我们的CDN加速节点遍布全球，正常情况下都能保证流畅播放。如仍有问题，请联系客服。',
  },
];